/**
 * Estados vazio e de erro.
 *
 * Existem como componentes, e não como um `if` em cada tela, porque as três
 * telas de tabela deste módulo têm o mesmo problema: um estado vazio que parece
 * um erro faz o usuário reportar um bug que não existe, e um erro que parece
 * vazio faz ele não reportar o bug que existe.
 *
 * ⚠️ **O terceiro estado, o de carregamento, mudou de casa.** Ele era um
 * `<Carregando>` com spinner e virou os esqueletos de `esqueleto.tsx` — um
 * spinner não tem tamanho, então a tela pulava quando os dados chegavam. Se
 * você procurava `Carregando` aqui, é lá.
 */
import type { ReactNode } from 'react'

import { mensagemDoErro } from './erros'
import { Botao } from './primitivos'

export function EstadoVazio({
  titulo,
  descricao,
  acao,
}: {
  titulo: string
  descricao?: string | undefined
  acao?: ReactNode
}) {
  return (
    <div className="text-text-muted flex flex-col items-center gap-2 p-10 text-center">
      <i className="ph ph-tray text-2xl" aria-hidden="true" />
      <p className="type-body-lg text-text-body">{titulo}</p>
      {descricao && <p className="type-sm max-w-md">{descricao}</p>}
      {acao}
    </div>
  )
}

/**
 * ⚠️ Mostra a mensagem que o SERVIDOR mandou, e não uma genérica.
 *
 * O módulo inteiro depende disso: o erro de gate do BR-20 diz qual campo falta,
 * o de conta duplicada diz o que houve, e o de conectividade da `2b` traz a
 * string crua da AWS — pedido explícito do Eduardo. Trocar tudo por "algo deu
 * errado" jogaria fora exatamente a informação que o backend se esforçou para
 * produzir.
 */
export function EstadoDeErro({
  erro,
  aoTentarNovamente,
}: {
  erro: unknown
  aoTentarNovamente?: () => void
}) {
  return (
    <div
      role="alert"
      className="rounded-card border-danger-500/30 bg-danger-100 flex flex-col items-start gap-3 border p-6"
    >
      <p className="text-danger-700 type-body">{mensagemDoErro(erro)}</p>
      {aoTentarNovamente && (
        <Botao variante="secundaria" icone="arrows-clockwise" onClick={aoTentarNovamente}>
          tentar novamente
        </Botao>
      )}
    </div>
  )
}
